var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlarmBell = function SvgAlarmBell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alarm-bell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.99,24.001c-0.47,0-0.939-0.12-1.356-0.348c-0.665-0.363-1.149-0.964-1.362-1.691c-0.117-0.397,0.111-0.814,0.508-0.931 c0.069-0.02,0.14-0.03,0.211-0.03c0.33,0,0.626,0.221,0.72,0.538c0.101,0.343,0.329,0.626,0.642,0.798 c0.197,0.107,0.417,0.164,0.638,0.164c0.127,0,0.255-0.019,0.379-0.055c0.438-0.129,0.777-0.468,0.906-0.906 c0.093-0.317,0.389-0.539,0.72-0.539c0.071,0,0.141,0.01,0.21,0.03c0.397,0.117,0.626,0.534,0.509,0.931 c-0.273,0.931-0.992,1.65-1.923,1.923C12.53,23.962,12.26,24.001,11.99,24.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.991,19.501c-0.285,0-0.549-0.165-0.674-0.421c-0.127-0.26-0.094-0.563,0.083-0.791c0.006-0.009,1.341-1.939,1.341-7.788 c0-4.293,3.266-7.835,7.5-8.216V0.751c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75v1.534c4.234,0.381,7.5,3.923,7.5,8.216 c0,6.303,1.246,7.686,1.258,7.699c0.218,0.199,0.297,0.532,0.187,0.818c-0.114,0.293-0.387,0.483-0.695,0.483H2.991z  M19.701,18.001c-0.482-1.232-0.961-3.47-0.961-7.5c0-3.722-3.028-6.75-6.75-6.75s-6.75,3.028-6.75,6.75 c0,3.957-0.58,6.277-1.046,7.5H19.701z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlarmBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alarm-bell.ccecdf6fcf8b302e2cb486cb29f051f6.svg";